<template>
  <div :id="filtro.filtro" class="container-multi-select">
    <div @click="toogleSelect" class="container-toogle-select" :style="styledFocusSelect(selectActive, ['border-color', 'color'])">
      <b class="flex-shrink-0">{{ label }}:</b>
      <span class="selecione" v-if="itemsSelecionados.length < 1" :style="styledFocusSelect(selectActive, ['color'])">Selecione</span>
      <span v-else class="items-selecionados-wrapper text-truncate flex-fill" :title="textoItensSelecionados">
        <span class="items-selecionados" v-for="(item, index) in itemsSelecionados" :key="item.id">
          {{ item.name }}<span v-if="index < itemsSelecionados.length - 1">,</span>
        </span>
      </span>
      <SVGIcon v-if="!filtro.default" class="flex-shrink-0" iconName="icon-close" :size="8" @click.stop="onExcluded" />
    </div>
    <div class="select-adicionar-campos" :class="{ 'abre-para-cima': abrirParaCima, 'abre-esquerda': abrirParaEsquerda }" v-if="selectActive">
      <div class="container-search">
        <i class="fa fa-search icn-search"></i>
        <input
          type="text"
          ref="inputSearch"
          class="ipt-search"
          placeholder="Busque pelo campo"
          v-model="search"
          @keyup="aoDigitar"
        />
      </div>
      <div v-if="buscaRemota && buscando" class="p-2">
        <SpinnerLoading :size="16" />
      </div>
      <div class="container-items">
        <div v-for="campo in camposFiltrados" :key="campo.id" class="item" @click="handleClickElementToChecked(campo.id)">
          <input
            type="checkbox"
            class="custom-checkbox"
            :name="campo.name"
            :id="campo.id"
            :value="campo.id"
            :checked="ehSelecionarTodos(campo.id) ? todosReaisSelecionados : itemsTemporariosIds.has(String(campo.id))"
            @click.stop="handleClickElementToChecked(campo.id)"
            :disabled="campo.default"
          />
          <span>{{ campo.name }}</span>
        </div>
      </div>
      <div class="container-button-aplicar">
        <button @click="salvar" class="btn btn-maino">Salvar</button>
      </div>
    </div>
  </div>
</template>
<script>
import SelectAdicionarCampos from '../components/SelectAdicionarCampos.vue';
import SVGIcon from '../../SvgIcon.vue';
import SpinnerLoading from '../../../../shared/SpinnerLoading.vue';

const EVENTO_ABRIR_SELECT = 'filtro:select:abrir';

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    campos: {
      type: Array,
      required: true
    },
    filtro: {
      type: Object,
      required: true
    },
    filtro_id: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    },
    buscaRemota: {
      type: Boolean,
      default: false
    },
    buscando: {
      type: Boolean,
      default: false
    },
    idSelecionarTodos: {
      type: String,
      default: null,
    },
  },
  emits: ['atualizar', 'buscar'],
  data() {
    return {
      selectActive: false,
      itemsSelecionados: [],
      itemsTemporarios: [],
      search: '',
      debounceTimeout: null,
      abrirParaCima: false,
      abrirParaEsquerda: false,
    }
  },
  computed: {
    camposComSelecionados() {
      if (!this.buscaRemota) return this.campos;

      const porId = new Map();
      this.itemsTemporarios.forEach(item => porId.set(String(item.id), { id: item.id, name: item.name }));
      this.campos.forEach(campo => porId.set(String(campo.id), campo));
      return Array.from(porId.values());
    },
    camposFiltrados() {
      return this.camposComSelecionados.filter(campo => {
         const name = this.$removeAccents(campo.name.toLowerCase())
         const search = this.$removeAccents(this.search.toLowerCase())
         return name.includes(search)
      })
    },
    itemsTemporariosIds() {
      return new Set(this.itemsTemporarios.map(item => String(item.id)));
    },
    todosReaisSelecionados() {
      if (!this.idSelecionarTodos) return false;
      const reais = this.campos.filter(campo => !this.ehSelecionarTodos(campo.id));
      return reais.length > 0 && reais.every(campo => this.itemsTemporariosIds.has(String(campo.id)));
    },
    textoItensSelecionados() {
      return this.itemsSelecionados.map(item => item.name).join(', ');
    }
  },
  components: {
    SelectAdicionarCampos,
    SVGIcon,
    SpinnerLoading,
  },
  methods: {
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    aoDigitar() {
      if (!this.buscaRemota) return;
      this.debounce(() => this.$emit('buscar', this.search), 300)();
    },
    toogleSelect() {
      this.selectActive = !this.selectActive;

      if (this.selectActive) {
        document.dispatchEvent(new CustomEvent(EVENTO_ABRIR_SELECT, { detail: { id: this.filtro.filtro } }));
        this.itemsTemporarios = [...this.itemsSelecionados];
        this.$nextTick(() => {
          this.ajustaDirecaoAbertura();
          this.$refs.inputSearch.focus();
        });
      } else {
        this.abrirParaCima = false;
        this.abrirParaEsquerda = false;
      }
    },
    ajustaDirecaoAbertura() {
      const container = document.getElementById(this.filtro.filtro);
      const dropdown = container?.querySelector('.select-adicionar-campos');
      if (!container || !dropdown) return;

      const retanguloContainer = container.getBoundingClientRect();
      const retanguloDropdown = dropdown.getBoundingClientRect();

      this.abrirParaCima = retanguloContainer.bottom + retanguloDropdown.height > window.innerHeight
        && retanguloContainer.top - retanguloDropdown.height > 0;
      this.abrirParaEsquerda = retanguloContainer.left + retanguloDropdown.width > window.innerWidth;
    },
    salvar() {
      this.itemsSelecionados = this.itemsTemporarios.filter(item => !this.ehSelecionarTodos(item.id));
      const selectedIds = this.itemsSelecionados.map(item => item.id);
      this.$emit('atualizar', selectedIds);
      this.selectActive = false;
    },
    onExcluded() {
      this.$store.commit('removeFiltro', this.filtro_id);
      this.$removeFiltroDaURL(this.filtro_id, this.path);
      this.$filtroDb.removeFiltro(this.path, this.filtro_id)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    styledFocusSelect(selectActive, styles) {
      if(!selectActive) return;

      let stylesTotal = [];
      styles.map(style => {
        stylesTotal.push(`${style}: var(--maino-blue-hover);`);
      })
      return stylesTotal.join(' ');
    },
    ehSelecionarTodos(id) {
      return Boolean(this.idSelecionarTodos) && String(id) === String(this.idSelecionarTodos);
    },
    handleClickElementToChecked(id) {
      if (this.ehSelecionarTodos(id)) {
        this.toggleSelecionarTodos();
        return;
      }

      const itemIndex = this.itemsTemporarios.findIndex(item => String(item.id) === String(id));

      if (itemIndex >= 0) {
        this.itemsTemporarios.splice(itemIndex, 1);
      } else {
        const campo = this.campos.find(c => String(c.id) === String(id));
        if (!campo) return;

        this.itemsTemporarios = [ ...this.itemsTemporarios, { id: campo.id, name: campo.name } ];
      }
    },
    toggleSelecionarTodos() {
      const camposReais = this.idSelecionarTodos
        ? this.campos.filter(c => String(c.id) !== String(this.idSelecionarTodos))
        : this.campos;

      const todosCheckados = camposReais.length > 0
        && camposReais.every(c => this.itemsTemporariosIds.has(String(c.id)));

      if (todosCheckados) {
        this.itemsTemporarios = [];
        return;
      }

      this.itemsTemporarios = this.campos.map(c => ({ id: c.id, name: c.name }));
    }
  },
  mounted() {
    const store = this.$store.state.filtroAplicados;
    if (store[this.filtro.filtro]) {
      const items = store[this.filtro.filtro].split(',').map(id => id.trim());
      this.itemsSelecionados = this.campos.filter(campo =>
        items.includes(String(campo.id))
      ).map(campo => ({
        id: campo.id,
        name: campo.name
      }));
    }

    this.fecharAoClicarFora = (event) => {
      if (!event.target.closest('.container-multi-select')) {
        this.selectActive = false;
        this.abrirParaCima = false;
        this.abrirParaEsquerda = false;
      }
    };
    this.fecharAoAbrirOutro = (event) => {
      if (event.detail.id !== this.filtro.filtro && this.selectActive) {
        this.selectActive = false;
        this.abrirParaCima = false;
        this.abrirParaEsquerda = false;
      }
    };
    document.addEventListener('click', this.fecharAoClicarFora);
    document.addEventListener(EVENTO_ABRIR_SELECT, this.fecharAoAbrirOutro);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.fecharAoClicarFora);
    document.removeEventListener(EVENTO_ABRIR_SELECT, this.fecharAoAbrirOutro);
  }
}
</script>
